export enum ScopeEnum {
    availableLicenses = 'AVAILABLE_LICENSES',
}
